export const START_ABBR_GAME_COMPLETED = "abbreviations/startCompleted";
export const GUESS_ABBR_COMPLETED = "abbreviations/guessCompleted";
export const GET_ABBR_SUGGESTIONS_COMPLETED = "abbreviations/suggestionsCompleted";
export const CLEAR_ABBR_SUGGESTIONS = "abbreviations/clearSuggestions";
